import { CarrierDto, KnownGroupStatus } from '@groundfloor-platform/mgmt-service-g-sdk';

export const NEEDS_REVIEW_LABEL = 'Needs review';
export const NEEDS_REVIEW_TOOLTIP =
  'Added by a courier at registration. Check it is not a duplicate, then approve or delete it.';

/** Values of the settings form's review field. */
export const CARRIER_REVIEW_APPROVED = 'approved';
export const CARRIER_REVIEW_NEEDS_REVIEW = 'needsReview';

type ReviewedCarrier = Pick<CarrierDto, 'isFlagged' | 'status'>;

const isDeleted = (carrier: ReviewedCarrier) => carrier.status === KnownGroupStatus.Deleted;

/** The flag is informative only, and moot once the carrier is deleted. */
export function needsReview(carrier: ReviewedCarrier): boolean {
  return carrier.isFlagged === true && !isDeleted(carrier);
}

export function canDeleteCarrier(carrier: ReviewedCarrier): boolean {
  return !isDeleted(carrier);
}

export function canAddCourier(carrier: ReviewedCarrier): boolean {
  return !isDeleted(carrier);
}

/** Unflagged reads as approved, including carriers from before the flag existed. */
export function carrierReview(carrier: ReviewedCarrier): string {
  return needsReview(carrier) ? CARRIER_REVIEW_NEEDS_REVIEW : CARRIER_REVIEW_APPROVED;
}
